import { useIsSplitEnabled } from '@buffer-mono/features'

/**
 * Announces the Start Page sunset (CORE-8022): the notices that tell owners
 * the product is being retired. Every announcement-phase change reads it, so
 * the announcement goes live for everyone with one flip.
 *
 * It covers the announcement only. The Start Page exporter gets its own Split.
 */
export const START_PAGE_SUNSET_ANNOUNCEMENT_FLAG =
  'start-page-sunset-announcement'

/**
 * Whether the Start Page sunset has been announced to this organization.
 *
 * Callers only show or hide something, and `isEnabled` defaults to `false`
 * while the SDK loads, which keeps today's behaviour. So no readiness check is
 * needed.
 */
export function useStartPageSunsetAnnouncementEnabled(): boolean {
  return useIsSplitEnabled(START_PAGE_SUNSET_ANNOUNCEMENT_FLAG)
}
